window.onload = function () {
  // Base sliders
  let swiper1_el = document.querySelector('#swiper-1');

  let autoplay = {
    delay: 6000,
    disableOnInteraction: true,
    pauseOnMouseEnter: false
  };

  if (document.querySelector('.l-good')) {
    autoplay = false;
  }

  if (swiper1_el) {
    var swiper1_prevs = new Swiper("#swiper-prevs-1", {
      spaceBetween: 0,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      loop: true,
      breakpoints: {
        992: {
          direction: "vertical",
          slidesPerView: 3
        }
      }
    });
    
    var swiper1 = new Swiper("#swiper-1", {
      spaceBetween: 10,
      effect: "fade",
      loop: true,
      autoplay: autoplay,
      navigation: {
        nextEl: ".swiper-button-next--1",
        prevEl: ".swiper-button-prev--1",
      },
      thumbs: {
        swiper: swiper1_prevs,
      },
    });
  }

  let swiper2_el = document.querySelector('#swiper-2');

  if (swiper2_el) {
    let swiper2_prevs = null;
    let swiper2_prevs_el = document.querySelector('#swiper-prevs-2');

    if (swiper2_prevs_el) {
      swiper2_prevs = new Swiper("#swiper-prevs-2", {
        spaceBetween: 0,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
        loop: true,
        breakpoints: {
          992: {
            direction: "vertical",
            slidesPerView: 3
          }
        }
      });
    }

    var swiper2 = new Swiper("#swiper-2", {
      spaceBetween: 10,
      effect: "fade",
      loop: true,
      autoplay: autoplay,
      navigation: {
        nextEl: ".swiper-button-next--2",
        prevEl: ".swiper-button-prev--2",
      },
      thumbs: {
        swiper: swiper2_prevs_el ? swiper2_prevs : null,
      },
    });
  }

  let swiper3_el = document.querySelector('#swiper-3');

  if (swiper3_el) {
    var swiper3 = new Swiper("#swiper-3", {
      spaceBetween: 10,
      effect: "fade",
      loop: true,
      autoplay: autoplay,
      navigation: {
        nextEl: ".swiper-button-next--3",
        prevEl: ".swiper-button-prev--3",
      }
    });
  }

  // Product slider
  let swiper_product_el = document.querySelector('#swiper-product');

  if (swiper_product_el) {
    var swiper_prevs_product = new Swiper("#swiper-product-prews", {
      spaceBetween: 0,
      slidesPerView: 3,
      freeMode: true,
      loop: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".swiper-button-preview-next--1",
        prevEl: ".swiper-button-preview-prev--1",
      },
      breakpoints: {
        992: {
          direction: "vertical",
          slidesPerView: 3
        }
      }
    });
    
    var swiper_products = new Swiper("#swiper-product", {
      spaceBetween: 10,
      effect: "fade",
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next--1",
        prevEl: ".swiper-button-prev--1",
      },
      thumbs: {
        swiper: swiper_prevs_product
      },
    });
  }

  // Fix subscrible form
  /*
  const lForm = document.querySelector('#l-form');

  if (lForm) {
    function getAbsoluteTop(el) {
      const rect = el.getBoundingClientRect();
      return rect.top + window.scrollY;
    }

    const formInitialTop = getAbsoluteTop(lForm);
    const formHeight = lForm.offsetHeight;
    const lFormBottom = formInitialTop + formHeight;

    window.addEventListener('scroll', function() {
      const scrollBottom = window.scrollY + window.innerHeight + 20;
      
      if (scrollBottom >= lFormBottom) {
        lForm.classList.add('fixed');
      } else {
        lForm.classList.remove('fixed');
      }
    });
  }
  */
}

const product_helper = {
  get_check_variant(color, size) {
    let variant_id = null;

    product_variants.forEach(element => {
      if (element.option1 === size) {
        $('.js--input-variant-id').val(element.id);

        if (!element.available) {
          $('.js--add-to-cart').prop('disabled', true);
          $('.notification-bar').removeClass('notification-bar--hide');
        } else {
          $('.js--add-to-cart').prop('disabled', false);
          $('.notification-bar').addClass('notification-bar--hide');
        }
      }

      // if (element.option2 === color) {
        $('.l-good__size-list-item[data-option="' + element.option1 + '"]').removeClass('l-good__size-list-item--unstock');

        if (!element.available) {
          $('.l-good__size-list-item[data-option="' + element.option1 + '"]').addClass('l-good__size-list-item--unstock');
        }
      //}
    });
  },
  
  update_quantity_options(selectId, stockLeft) {
    const quantitySelect = document.getElementById(selectId);
    
    if (!quantitySelect) {
      return;
    }

    Array.from(quantitySelect.options).forEach(option => {
        const value = parseInt(option.value);

        if (value > stockLeft) {
            option.style.display = 'none';
            option.disabled = true;
        } else {
            option.style.display = '';
            option.disabled = false;
        }
    });

    if (parseInt(quantitySelect.value) > stockLeft) {
        quantitySelect.value = stockLeft > 0 ? stockLeft : 1;
    }
  }
};

$(function () {
  $(document).on('click', '.js--subscrible-open', function(event) {
    event.preventDefault();

    $('.m-form').addClass('m-form--active');
  });

  if (typeof product_variants !== 'undefined')  {
    if ($('.l-good__size-list-item').length) {
      product_helper.get_check_variant($('.l-good__more-item--active').data('option'), $('.l-good__size-list-item--active').data('option'));

      $(document).on('click', '.l-good__size-list-item', function(event) {
        event.preventDefault();

        if ($(this).hasClass('l-good__size-list-item--active')) {
          return;
        }

        $('.l-good__size-list-item--active').removeClass('l-good__size-list-item--active');      
        $(this).addClass('l-good__size-list-item--active');

        product_helper.get_check_variant($('.l-good__more-item--active').data('option'), $('.l-good__size-list-item--active').data('option'));
        
        let stock = product_variants_stocks[$('.js--input-variant-id').val()];
        product_helper.update_quantity_options($('.js--input-quantity').attr('id'), stock);
      });
    } else {
        let stock = product_variants_stocks[$('.js--input-variant-id').val()];
        product_helper.update_quantity_options($('.js--input-quantity').attr('id'), stock);

        if (stock <= 0) {
          $('.js--add-to-cart').prop('disabled', true);
          $('.notification-bar').removeClass('notification-bar--hide');
        } else {
          $('.js--add-to-cart').prop('disabled', false);
          $('.notification-bar').addClass('notification-bar--hide');
        }
    }

    function renderCartItems(items) {
      return items.map(item => {
        const formattedPrice = item.price / 100; 
        const imageUrl = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_medium$1$2') : '';

        return `
          <div class="cart__item" data-id="${item.id}" data-quantity="${item.quantity}" data-price="${formattedPrice}">
            <a href="${item.url}" class="cart__item-img" style="background-image:url(${imageUrl});"></a>
            <div class="cart__item-in">
              <a href="${item.url}" class="cart__item-title">${item.product_title}</a>
              
              ${item.variant_title ? `<div class="cart__item-info">${item.variant_title}</div>` : ''}

              <div class="cart__item-line">
                <div class="counter" data-id="${item.id}">
                    <button class="counter__minus" type="button">-</button>
                    <input type="number" class="counter__val" readonly="" value="${item.quantity}">
                    <button class="counter__plus" type="button">+</button>
                </div>
                <div class="cart__item-price">€${formattedPrice}</div>
              </div>
            </div>
          </div>`;
      }).join('');
    }

    function calculateCartTotal(items) {
      const totalCents = items.reduce((sum, item) => sum + (item.final_line_price || item.line_price), 0);
      return totalCents / 100;
    }


    $(document).on('click submit', '.js--add-to-cart', function (event) {
      event.preventDefault();

      let self = $(this),
          form = self.parents('form');

      let formData = {
        'items': [{
          'id': form.find('.js--input-variant-id').val(),
          'quantity': form.find('.js--input-quantity').val()
        }],
        attributes: {
          'ref_link': app_cookie.get(SHOPIFY_REF_COOKIE_NAME)
        }
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          alert(data.message);
        } else {
          $('.cart').addClass('cart--open');

          if (data.items) {
            $('.cart__empty').hide();
            $('.cart__items').append(renderCartItems(data.items));
            $('.cart__bottom').show();

            let total_sum = 0,
                total_qty = 0;

            $('.cart__items .cart__item').each(function() {
              total_sum += ~~$(this).data('price') * ~~$(this).data('quantity');
              total_qty += ~~$(this).data('quantity');
            });

            $('.l-nav__item-sum').text(total_qty);
            $('.mob-cart__count').text(total_qty);
            $('.cart__bottom-total-sum').text('€' + total_sum);
          }
        }
      }).catch((error) => {
        if (error.status === 422) {
          alert(error.message);
        }

        console.log(error);
      });
    });
  }

  $(document).on('click', '#js-open-smart-size', function (event) {
    event.preventDefault();

    $('.smartsize-button__icon').click();
  });

  $(document).on('click', '.cart__close, .cart__overlay', function (event) {
    event.preventDefault();

    $('.cart').removeClass('cart--open');
  });

  $(document).on('click', '.l-nav__item--cart, .mob-cart', function (event) {
    event.preventDefault();

    $('.cart').toggleClass('cart--open');
  });

  document.addEventListener('click', (e) => {
    const cartElement = document.querySelector('.cart');

    if (cartElement && cartElement.classList.contains('cart--open')) {
      if (!e.target.closest('.cart') && !e.target.closest('.l-nav__item--cart') && !e.target.closest('.mob-cart')) {
        cartElement.classList.remove('cart--open');
      }
    }
  });

  $(document).on('click', '.burger-menu', function (event) {
    event.preventDefault();
    $('.sidebar').toggleClass('sidebar--open');
  });

  $(document).on('click', '.sidebar__close', function (event) {
    event.preventDefault();
    $('.sidebar').removeClass('sidebar--open');
  });

  // Обработка кликов по кнопкам + и -
  $(document).on('click', '.counter__plus, .counter__minus', function() {
      const $counter = $(this).closest('.counter');
      const $input = $counter.find('.counter__val');
      const id = $counter.data('id');
      const currentQty = parseInt($input.val());

      let newQty = $(this).hasClass('counter__plus') ? currentQty + 1 : currentQty - 1;

      if (newQty < 0) return;

      $counter.find('button').prop('disabled', true);
      updateCart(id, newQty, $input, $counter);
  });

  // Функция отправки запроса в Shopify API
  function updateCart(id, quantity, $input, $counter) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: id,
        quantity: quantity,
        attributes: {
          'ref_link': app_cookie.get(SHOPIFY_REF_COOKIE_NAME)
        }
      },
      dataType: 'json',
      success: function(cart) {
        $input.val(quantity);
        $counter.find('button').prop('disabled', false);

        if (cart.total_price) {
          $('.cart__bottom-total-sum').text('€' + (cart.total_price / 100).toFixed(0));
          
          if (quantity === 0) {
            $counter.parents('.cart__item').remove();
          }
        } else {
          $('.cart__items').html('<p class="cart__empty">Cart is empty.</p>');
          $('.cart__bottom').hide();
        }

        $('.l-nav__item-sum').text(cart.item_count);
      },
      error: function(error) {
        console.log(error);

        if (error.status === 422) {
          alert(error.message);
        }

        $counter.find('button').prop('disabled', false);
      }
    });
  }
});



// Fixed logo block
window.addEventListener('scroll', function() {
  const logoBlock = document.querySelector('.logo-block');

  if (window.scrollY > 50) {
    logoBlock.classList.add('logo-block--s');
  } else {
    logoBlock.classList.remove('logo-block--s');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#ajax-newsletter-form');
  if (!form) return;

  const successMsg = form.querySelector('.form-status-success');
  const errorMsg = form.querySelector('.form-status-error');
  const errorMsgNotice = form.querySelector('.form-status-error-notice');
  const formLine = form.querySelector('.l-form__line');
  const emailInput = form.querySelector('input[type="email"]');
  const agreeBlock = form.querySelector('.l-form__checkbox');
  const agreeInput = form.querySelector('input[name="agree"]');
  const submitBtn = form.querySelector('.l-form__btn');

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    
    if (agreeInput && agreeInput.checked) {
      if (errorMsgNotice) {
        errorMsgNotice.style.display = 'none';
      }
    } else {
      if (errorMsgNotice) {
        errorMsgNotice.style.display = 'block';
      }

      return;
    }

    if (emailInput && !emailInput.value.includes('@')) {
      if (errorMsg) errorMsg.style.display = 'block';
      return;
    }

    if (submitBtn) submitBtn.disabled = true;

    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    const fetchUrl = window.Shopify ? window.Shopify.routes.root + 'contact' : '/contact';

    fetch(fetchUrl, {
      method: 'POST',
      body: searchParams,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.url && response.url.includes('/challenge')) {
        console.warn('Shopify safety check bypassed via background thread.');
      }

      if (formLine) formLine.style.display = 'none';
      if (successMsg) successMsg.style.display = 'block';
      if (errorMsg) errorMsg.style.display = 'none';
      if (agreeBlock) agreeBlock.style.display = 'none';
      
      form.reset();
    })
    .catch(error => {
      if (submitBtn) submitBtn.disabled = false;
      if (errorMsg) errorMsg.style.display = 'block';
      console.error('Newsletter submit error:', error);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#m-ajax-newsletter-form');

  if (!form) {
    return;
  }

  const successMsg = form.querySelector('.form-status-success');
  const errorMsg = form.querySelector('.form-status-error');
  const errorMsgNotice = form.querySelector('.form-status-error-notice');
  const formLine = form.querySelector('.m-form__line');
  const formText = form.querySelector('.m-form__text');
  const emailInput = form.querySelector('input[type="email"]');
  const agreeBlock = form.querySelector('.m-form__checkbox');
  const agreeInput = form.querySelector('input[name="agree"]');
  const submitBtn = form.querySelector('.m-form__btn');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    if (agreeInput && agreeInput.checked) {
      if (errorMsgNotice) {
        errorMsgNotice.style.display = 'none';
      }
    } else {
      if (errorMsgNotice) {
        errorMsgNotice.style.display = 'block';
      }

      return;
    }


    if (emailInput && !emailInput.value.includes('@')) {
      if (errorMsg) errorMsg.style.display = 'block';
      return;
    }

    if (submitBtn) submitBtn.disabled = true;

    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    const fetchUrl = window.Shopify ? window.Shopify.routes.root + 'contact' : '/contact';

    fetch(fetchUrl, {
      method: 'POST',
      body: searchParams,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.url && response.url.includes('/challenge')) {
        console.warn('Shopify safety check bypassed via background thread.');
      }

      if (formLine) formLine.style.display = 'none';
      if (successMsg) successMsg.style.display = 'block';
      if (errorMsg) errorMsg.style.display = 'none';
      if (agreeBlock) agreeBlock.style.display = 'none';
      if (formText) formText.style.display = 'none';

      form.reset();
    })
    .catch(error => {
      if (submitBtn) submitBtn.disabled = false;
      if (errorMsg) errorMsg.style.display = 'block';
      console.error('Newsletter submit error:', error);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('CustomRegionForm');
  const select = document.querySelector('.switch-region__select');
  const closeBtn = document.querySelector('.switch-region__close');
  const popup = document.querySelector('.switch-region');

  if (form && select) {
    form.addEventListener('submit', function(e) {
    });

    select.addEventListener('change', function() {
      form.submit();
    });
  }

  // Логика закрытия попапа по крестику (просто скрываем элемент)
  if (closeBtn && popup) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      popup.style.display = 'none';
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // Получить значение параметра 'ref'
  const geoModal = urlParams.get('geo-modal');

  if (geoModal) {
    $('.switch-region').show();
  }



  const forms = document.querySelectorAll('.subscribe-form');
  
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const successMsg = form.querySelector('.form-status-success');
      const errorMsg = form.querySelector('.form-status-error');
      const errorMsgNotice = form.querySelector('.form-status-error-notice');
      const emailInput = form.querySelector('.email-input');
      const agreeBlock = form.querySelector('.subscribe-form__checkbox');
      const agreeInput = form.querySelector('input[name="agree"]');
      const submitBtn = form.querySelector('.submit-btn');

      if (agreeInput && agreeInput.checked) {
        if (errorMsgNotice) {
          errorMsgNotice.style.display = 'none';
        }
      } else {
        if (errorMsgNotice) {
          errorMsgNotice.style.display = 'block';
        }

        return;
      }

      if (emailInput && !emailInput.value.includes('@')) {
        if (errorMsg) errorMsg.style.display = 'block';
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
      }

      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      const fetchUrl = window.Shopify ? window.Shopify.routes.root + 'contact' : '/contact';

      fetch(fetchUrl, {
        method: 'POST',
        body: searchParams,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (response.url && response.url.includes('/challenge')) {
          console.warn('Shopify attempted to enforce captcha, processing in background...');
        }

        if (emailInput) {
          emailInput.style.display = 'none';
          emailInput.blur();
        }

        if (agreeBlock) agreeBlock.style.display = 'none';
        
        if (submitBtn) {
          submitBtn.style.display = 'none';
        }
        
        if (successMsg) {
          successMsg.style.display = 'block';
        }
        
        if (errorMsg) {
          errorMsg.style.display = 'none';
        }

        if (errorMsgNotice) {
          errorMsgNotice.style.display = 'none';
        }

        setTimeout(function () {
          if (emailInput) {
            emailInput.style.display = 'block';
          }

          if (submitBtn) {
            submitBtn.style.display = 'block';
          }

          if (successMsg) {
            successMsg.style.display = 'none';
          }

          if (errorMsg) {
            errorMsg.style.display = 'none';
          }

          if (agreeBlock) {
            agreeBlock.style.display = 'block';
          }
        }, 45000);

        form.reset();
      })
      .catch(error => {
        if (submitBtn) submitBtn.disabled = false;
        if (errorMsg) errorMsg.style.display = 'block';
        console.error('Shopify Form Submit Error:', error);
      });
    });
  });
});




// Fixed navigation
window.addEventListener('scroll', function() {
  const nav = document.querySelector('.l-nav');

  if (nav) {
    const vh = window.innerHeight;
    const navHeight = nav.offsetHeight;
    const offset = 20;

    if (window.scrollY >= (vh - navHeight - offset)) {
      nav.classList.add('l-nav--top');
    } else {
      nav.classList.remove('l-nav--top');
    }
  }
});


const app_cookie = {
  get: function (name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));

    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  set: function (name, value, days = 7) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + date.toUTCString() + "; path=/";
  }
};


const subscrible_modal = {
  cookie_name : 'shopify_subscribed_modal',
  remove: function () {
    const modal = document.getElementById("m-form");
    
    if (!modal) {
      return;
    }
    
    modal.classList.remove("m-form--active");
  },
  show: function () {
    const modal = document.getElementById("m-form");

    if (modal) {
      modal.classList.add("m-form--active");
    }
    console.log("Модальное окно подписки показано");

    app_cookie.set(subscrible_modal.cookie_name, "viewed", 7);
    localStorage.removeItem("shopify_site_time");
  }
};

const geo_modal = {
  cookie_name : 'shopify_geo_modal',
  remove: function () {
    const modal = document.getElementById("switch-region");
    
    if (!modal) {
      return;
    }
    
    modal.classList.remove("switch-region--active");
  },

  show: function () {
    const modal = document.getElementById("switch-region");

    if (modal) {
      modal.classList.add("switch-region--active");
    }
    console.log("Модальное окно подписки показано");

    app_cookie.set(geo_modal.cookie_name, "viewed", 7);
    localStorage.removeItem("shopify_site_time");
  }
};


document.addEventListener("DOMContentLoaded", function () {
  if (!app_cookie.get(subscrible_modal.cookie_name)) {
    const modal = document.getElementById("m-form");

    if (modal && !modal.classList.contains("m-form--cart")) {
      const targetTime = 60;
      const storageKey = "shopify_site_time_subscrible";

      let currentTime = parseInt(localStorage.getItem(storageKey), 10) || 0;

      const timerInterval = setInterval(function () {
        const modal = document.getElementById("switch-region");

        if (modal && modal.classList.contains("switch-region--active")) {
          currentTime = 20;
        } else {
          currentTime++;
        }
        localStorage.setItem(storageKey, currentTime);

        if (currentTime >= targetTime) {
          clearInterval(timerInterval);
          subscrible_modal.show();
        }
      }, 1000);
    }
  }

  if (!app_cookie.get(geo_modal.cookie_name)) {
    const targetTime = 7;
    const storageKey = "shopify_site_time_geo";

    let currentTime = parseInt(localStorage.getItem(storageKey), 10) || 0;

    const timerIntervalGeo = setInterval(function () {
      currentTime++;
      localStorage.setItem(storageKey, currentTime);

      if (currentTime >= targetTime) {
        clearInterval(timerIntervalGeo);
        geo_modal.show();
      }
    }, 1000);
  }
});



document.addEventListener("click", function (event) {
  const modal = document.getElementById("m-form");

  if (!modal || !modal.classList.contains("m-form--active")) {
    return;
  }

  if (event.target.closest(".m-form__close")) {
    subscrible_modal.remove();
    return;
  }
  
  if (event.target === modal) {
    subscrible_modal.remove();
  }
});

document.addEventListener("click", function (event) {
  const modal = document.getElementById("switch-region");

  if (!modal || !modal.classList.contains("switch-region--active")) {
    return;
  }

  if (event.target.closest(".switch-region__close")) {
    geo_modal.remove();
    return;
  }
  
  if (event.target === modal) {
    geo_modal.remove();
  }
});



// Save ref links
const SHOPIFY_REF_COOKIE_NAME = 'shopify_ref_link';

$(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const refLink = urlParams.get('ref_link');

  if (refLink) {
    app_cookie.set(SHOPIFY_REF_COOKIE_NAME, refLink, 14);
  }
});